package com.essntl.features.client.ui

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import core.dateformat.utils.parseLocalDateOrNull
import kotlinx.datetime.Clock
import kotlinx.datetime.TimeZone
import kotlinx.datetime.periodUntil
import kotlinx.datetime.toLocalDateTime

@Composable
fun rememberClientAge(
    dateOfBirth: String?,
): Int {
    return remember(dateOfBirth) {
        val birthDate = parseLocalDateOrNull(dateOfBirth) ?: return@remember -1
        val nowDate = Clock.System.now().toLocalDateTime(TimeZone.UTC).date

        birthDate.periodUntil(nowDate).years
    }
}